import React from 'react'
import {
    Autocomplete,
    Button,
    CircularProgress,
    TextField
} from '@mui/material'
import { useCity, SelectedCity } from '../../context/CityContext'
import { useCityGeolocation } from '../../hooks/useCityGeolocation'
import { GetCitiesQuery, useGetCitiesQuery } from './__generated__/CityBar'

type CityItem = GetCitiesQuery['cities'][number]

export const CityBar: React.FC = () => {
    const { selectedCity, setSelectedCity } = useCity()
    const locate = useCityGeolocation()
    const { data } = useGetCitiesQuery()
    const [locating, setLocating] = React.useState(false)
    const [manual, setManual] = React.useState(false)
    const resolvedRef = React.useRef(false)

    const cities = (data?.cities ?? []).filter((c) => c.active !== false)

    const toSelected = (city: CityItem): SelectedCity => ({
        id: city.id,
        name: city.name,
        latitude: city.latitude,
        longitude: city.longitude,
        countryId: city.countryId
    })

    // При монтировании определяем город по гео; если гео не разрешено — селект.
    React.useEffect(() => {
        if (resolvedRef.current || !data) return
        resolvedRef.current = true
        setLocating(true)
        locate()
            .then((city) => setManual(!city))
            .catch(() => setManual(true))
            .finally(() => setLocating(false))
    }, [data, locate])

    const handleLocate = async () => {
        setLocating(true)
        try {
            const city = await locate()
            if (city) setManual(false)
        } catch {
            setManual(true)
        } finally {
            setLocating(false)
        }
    }

    if (!manual && selectedCity) {
        return (
            <div
                className='city-bar'
                style={{ display: 'flex', alignItems: 'center', gap: 8 }}
            >
                <span className='location__city'>{selectedCity.name}</span>
                <Button
                    size='small'
                    variant='outlined'
                    onClick={() => setManual(true)}
                >
                    Сменить
                </Button>
            </div>
        )
    }

    return (
        <div
            className='city-bar'
            style={{ display: 'flex', alignItems: 'center', gap: 8 }}
        >
            <Autocomplete
                size='small'
                sx={{ width: 200 }}
                options={cities}
                value={cities.find((c) => c.id === selectedCity?.id) ?? null}
                getOptionLabel={(c) => c.name}
                onChange={(_, value) =>
                    setSelectedCity(value ? toSelected(value) : null)
                }
                renderInput={(params) => (
                    <TextField {...params} label='Город' />
                )}
            />
            <Button
                size='small'
                variant='outlined'
                onClick={handleLocate}
                disabled={locating}
                endIcon={locating ? <CircularProgress size={14} /> : null}
            >
                Определить
            </Button>
        </div>
    )
}
